'use client';

import React, { useEffect, useState } from 'react';
import { InlineWidget } from 'react-calendly';
import CloseButton from '../Elements/CloseButton';
type CalendlyModalProps = {
  isOpen: boolean;
  onClose: () => void;
  url: string;
};
const CalendlyModal: React.FC<CalendlyModalProps> = ({
  isOpen,
  onClose,
  url
}) => {
  const [visible, setVisible] = useState(false);
  const [transitioning, setTransitioning] = useState(false);
  useEffect(() => {
    if (isOpen) {
      setVisible(true);
      setTimeout(() => setTransitioning(true), 10);
    } else {
      setTransitioning(false);
      setTimeout(() => setVisible(false), 300);
    }
  }, [isOpen]);
  if (!visible) return null;
  return <div className={`fixed inset-0 bg-black bg-opacity-65 flex justify-center items-center z-50 transition-opacity duration-300 ${transitioning ? 'opacity-100' : 'opacity-0'}`} data-sentry-component="CalendlyModal" data-sentry-source-file="CalendlyModal.tsx">
      <div className={`rounded-2xl max-w-5xl w-full transform transition-transform duration-300 ${transitioning ? 'scale-100' : 'scale-95'}`}>
        <div className="relative">
          <CloseButton className="absolute top-2.5 right-2.5 bg-white" onClose={onClose} fill="black" data-sentry-element="CloseButton" data-sentry-source-file="CalendlyModal.tsx" />
        </div>
        <InlineWidget url={url} styles={{
        height: '700px'
      }} data-sentry-element="InlineWidget" data-sentry-source-file="CalendlyModal.tsx" />
      </div>
    </div>;
};
export default CalendlyModal;